import React from "react";
import { Banner } from "../../interfaces/banner.interface";

const HeroBanner = (props: { banners: Banner[] }) => {
  const banner = props.banners[0];

  if (!banner) return null;

  const heroImage = (
    <picture>
      <source media="(min-width: 600px)" srcSet={banner.desktopImage} />
      <source media="(max-width: 599px)" srcSet={banner.mobileImage} />
      <img src={banner.desktopImage} alt={banner.title} />
    </picture>
  );

  return (
    <div className="hero-banner" key={banner.desktopImage}>
      {banner.url ? (
        <a href={banner.url} target={banner.target} rel="nofollow">
          {heroImage}
        </a>
      ) : (
        heroImage
      )}
    </div>
  );
};

export default HeroBanner;
